export default __webpack_public_path__ + "static/media/ophi_sword.512662d8.bmp";